module.exports = __webpack_public_path__ + "media/images/icon-arrow-prev-c4ca38bd6f3dd696f6e3172878f5c082.svg";